import React from 'react';
import styled from 'styled-components';
import { RedAsterisk } from '../../common';
import SidePanelLink from './SidePanelLink';

interface Props {
	item: any;
	provided?: any;
	onExpand?: (itemId: any) => void;
	onCollapse?: (itemId: any) => void;
	onLabelClick?: () => void;
}

const SidePanelLinkContainer = (props: Props) => {
	const { item, provided } = props;
	const { data } = item;
	const selected = data.selected;

	return (
		<div ref={provided?.innerRef} {...provided?.draggableProps}>
			<Container className={`side-panel-link ${item.data.className}`}>
				<SidePanelLink
					selected={selected}
					// icon={getIcon(item, onExpand, onCollapse)}
					to={item.data.link}
				>
					{item.data ? item.data.title : ''}
					{data.hasError ? <RedAsterisk /> : null}
				</SidePanelLink>
			</Container>
		</div>
	);
};

const Container = styled.div`
	&.peril {
		text-transform: capitalize;
	}
	&.perils {
		text-transform: capitalize;
	}
	&.exposure {
		text-transform: capitalize;
	}
`;

export default SidePanelLinkContainer;
